import React from "react";
import { Flex, theme, Typography, Row, Col } from "antd";
import { Link } from "react-router-dom";

import "./styles.css";

export const Logo = ({ asLink, color, href, imgSize, bgColor, ...others }) => {
    const {
        token: { borderRadius },
    } = theme.useToken();

    return (
        <Row  justify="center" align="center" gutter={[16, 16]}>
            <Col xs={24} sm={12}>
                <img src={require("../../../../public/images/android-chrome-192x192.png")} alt="design sparx logo" height={imgSize?.h || 48} />
            </Col>
            <Col xs={0} sm={12}>
                <Link to={href || "#"} className="logo-link">
                    <Typography.Title
                        level={5}
                        type="secondary"
                        className="text-center"
                        style={{
                            color,
                            margin: 0,
                            padding: `4px 8px`,
                            backgroundColor: bgColor,
                            borderRadius,
                        }}>
                        ToDoor
                    </Typography.Title>{" "}
                </Link>
            </Col>
        </Row>
    );
};
